export enum GraphType {
  EnrolmentType = 1,
  Sector = 2,
  SiteService = 3,
}

export enum GraphColorsPallete {
  lightBlue = "#6896E9",
  lightGreen = "#68b770",
  yellow = "#E9B55E",
  pink = "#D75F8F",
  purple = "#A574B9",
  cyan = "#68ABB7",
  brown = "#b78f68",
  darkGreen = "#679375",
  olive = "#b3b768",
}
